import { render, staticRenderFns } from "./EditProfilePicture.vue?vue&type=template&id=a945e9a6&"
import script from "./EditProfilePicture.vue?vue&type=script&lang=js&"
export * from "./EditProfilePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports